import React from 'react'
import { processQuery, crudQuery } from '../../views/Tree/Utils'
import YSpinner from  '../Spinner/Spinner'
//import { displayQueryResults } from './QBDisplayResults'
import { qb_translateLine } from './QBTranslate'
import { fieldTypeMap } from './QBMapField'

import { XLDownload } from './QBExportCSV'
export class QBDemo extends React.Component {
    constructor (props){
        super(props)
        this._isMounted = false
        this.state ={
            data: "",
            rules: "",
            gcond: "",
            result: "",
            // not sure if the above needed - beware of rules! must check it!
            isUpdating: false,
            selectedRule: "",
            preDefinedQueries: [],
            domainList: ['משפחה','הורים'],
            familyTabList: "",
            parentTabList: "",
            familyFieldList: "",
            parentFieldList: "",
            groupCond : "AND", // ['AND'], ['OR']
            rulelist:  [{entity: "", phase:"", tab: "", field: "", condition: "", input:""}]
        }
        this.ruleParamChange2 = this.ruleParamChange2.bind(this)
        this.addRule = this.addRule.bind(this)
        this.removeRule = this.removeRule.bind(this)
        this.duplicateRule = this.duplicateRule.bind(this)
        this.upRule = this.upRule.bind(this)
        this.setActive = this.setActive.bind(this)
        this.showListQueryCb = this.showListQueryCb.bind(this)
        this.getPhases = this.getPhases.bind(this)
        this.getDomain = this.getDomain.bind(this)
        this.initTabs = this.initTabs.bind(this)
        this.initFields = this.initFields.bind(this)
        this.initMap = this.initMap.bind(this)
        this.inUpdate = this.inUpdate.bind(this)
        this.showMe = this.showMe.bind(this)
        this.validateQuery = this.validateQuery.bind(this)
        this.saveQueryCb = this.saveQueryCb.bind(this)
        this.listFind = this.listFind.bind(this)
        this.saveQuery = this.saveQuery.bind(this)
        this.doQuery = this.doQuery.bind(this)
        this.displayLine = this.displayLine.bind(this)
        this.displayQueryResults = this.displayQueryResults.bind(this)
        this.selectRule = this.selectRule.bind(this)
        this.PreDefinedRuleList = this.PreDefinedRuleList.bind(this)
        this.delQueryDefinitionCb = this.delQueryDefinitionCb.bind(this)
        this.delQueryDefinition = this.delQueryDefinition.bind(this)
        this.isActive = this.isActive.bind(this)

    }
    restError = (msg) => alert(' תקלת תקשורת חולפת - נא לנסות שוב' + msg)
    componentDidMount(){ // add constructor..
        this._isMounted = true       
        processQuery('init-tabs', "empty", this.inUpdate, this.props.mbouser, this.initMap, this.restError); // cb
        crudQuery('GET', 0, "", "", "", this.inUpdate, this.props.mbouser, this.showListQueryCb, this.restError)
    }
    /*ruleParamChange = (event, item) => {
        event.preventDefault()
        this.setState({ [item]: event.target.value })
    }*/
    ///////// Below are all rule editing operations 
    ruleParamChange2 = (event, item, index) => {
        event.preventDefault()
        let rli = [...this.state.rulelist]
        rli[index][item] = event.target.value
        if (item === 'entity'){
            //rli[index]['phase'] = ""
            rli[index]['tab'] = ""
            rli[index]['field'] = ""
            rli[index]['condition'] = ""
            rli[index]['input'] = ""
        }
        if (item === 'tab') // make sure its empty
            rli[index]['input'] = ""
        
        if (item === 'condition' && event.target.value === "")
            rli[index]['input'] = ""

        if (event.target.value === "בטווח" || event.target.value === "מחוץ לטווח") // Rule compose validation
            rli[index]['input'] = ""

        this.setState({ rulelist: rli, selectedRule: "" })
    }
    addRule = (event) => {
        event.preventDefault()
        let rl = [...this.state.rulelist]
        let newrule = {entity: "", phase:"", tab: "", field: "", condition: "", input:""}
        this.setState({rulelist: [...rl, newrule], selectedRule: ""})
    }
    removeRule = (event, index) => {
        event.preventDefault()
        let rl = [...this.state.rulelist]
        rl.splice(index, 1)
        this.setState({rulelist: rl, selectedRule: ""})
        //console.log('removeRule index='+ index)
    }
    duplicateRule = (event, index) => {
        event.preventDefault()
        let rl = Object.assign(this.state.rulelist)
        let newrule = {entity: "", phase:"", tab: "", field: "", condition: "", input:""}
        rl.push(newrule)
        let last = rl.length-1
        Object.keys(rl[index]).map(k  => rl[last][k] = rl[index][k])
        this.setState({rulelist: rl, selectedRule: ""})
        //console.log('duplicateRule index='+ index)
    }
    upRule = (event, index, up) => {
        event.preventDefault()
        if (up && index < 1) return
        if (!up && index >= this.state.rulelist.length-1) return

        let rl = Object.assign(this.state.rulelist)
        let t = Object.assign(rl[index])
        if (up){
            rl[index] = Object.assign(rl[index-1])
            rl[index-1] = Object.assign(t)
        } else {
            rl[index] = Object.assign(rl[index+1])
            rl[index+1] = Object.assign(t)
        }
        this.setState({rulelist: rl, selectedRule: ""})
        //console.log('upRule index='+ index)
    }
    setActive = (event, cond) => {
        event.preventDefault()
        this.setState({groupCond: cond, selectedRule: ""})
    }
///////// last rule editinig operations 

    showListQueryCb = (crud, parcel) => {
        if (parcel === undefined || parcel.length < 1 || crud !== 'GET')
            return null
        // parse parcel
        let res = Object.keys(parcel).map(qid => {
            let jd = parcel[qid]
            let jdata = JSON.parse(jd)
            let d = jdata['body']
            return({name: d.qtitle, cond: d.cond, rules: d.rules, id: qid})
        })
        function compare( a, b ) {
            if ( a.name < b.name ) return -1;
            if ( a.name > b.name ) return 1;
            return 0;
        }
        res.sort( compare );
        this.setState({preDefinedQueries: res})
    }
    getPhases = line => {
        let phases = ['category:snapshot', 'category:psnapshot']
        if (line.locations === undefined || line.locations === "")
            return []
        let targetPhase = ""
        line.locations.map(loc =>{
            if (phases.includes(loc) && targetPhase !== loc){
                targetPhase = loc
            }
            return null
        })
        if (targetPhase === "")
            return ["מצב נוכחי"]
        return ['תחילת תוכנית', 'אמצע תוכנית', 'סיום תוכנית', 'מצב נוכחי']
    }
    getDomain = line => {
        let domains = ['digma_referrals', 'digma_intakes', 'digma_families', 'digma_parents']
        if (line.locations === undefined || line.locations === "")
            return ""
        let targetDomains = []
        
        line.locations.map(loc =>{
            if (domains.includes(loc) && !targetDomains.includes(loc)){
                targetDomains = [...targetDomains, loc]
            }
            return null
        })
        //console.log(line)
        //console.log(targetDomains)
        return targetDomains
    }
    initTabs = (data, entity) => {
        let unused = ["צרכים ומענים כללי", "בני המשפחה", "אינטייק-referrals", "תוכנית עבודה כלכלת משפחה", "תוכנית עבודה לתעסוקה",
                    "תוכנית עבודה לנושאים משפחתיים", "תמונות מצב", "מאזן הכנסות והוצאות" , "משפחה - פרטים ראשונים", "מידע אינטייק",
                     ] // "שאלון אינטייק למשפחה", "סטטוס אינטייק"
        let tabs = Object.keys(data).map(line => {
            let dl = data[line]
            let domains = this.getDomain(dl)
            if (domains === null)
                return null
            if (domains.includes(entity) && !unused.includes(entity))
                return dl.title
            return null
            // let phases = this.getPhases(dl)
            //let tab = {label: dl.fields[0].label, name: dl.fields[0].name, type: dl.fields[0].type, fields: dl.fields[0].type}
            //console.log(data[line])
            //return this.getDomainPhase(data[line])
        })
        tabs = tabs.filter(item => !unused.includes(item))
        tabs = tabs.filter(item => item !== null)
        ////console.log("Entity =" + entity)
        ////console.log(tabs)
        return tabs.sort()
    }
    initFields = (tabName, data) => {
        let found = Object.values(data).find(item => tabName === item['title'])
        //console.log(found)
        let dl = found['fields'][0]
        let type = dl === undefined ? 'null' : dl['type']
        //if (!dl['sub_fields'].isArray){
        //    console.log('NOT ARRAY =' + tabName)
        //    return ([tabName, type, null])
        //}
        let fieldNames = Object.entries(dl['sub_fields']).map(item => item[1]) 

     /*   let list = Object.entries(found).map(line => {
            let dl = line['fields'][0]
            //let dl = data[line]['fields'][0]
            let fieldNames = Object.keys(dl['sub_fields']).map(item => item['label'])
            return ([tabName, data[line]['label'], [type, fieldNames ]])
        })*/
        return ([tabName, type, fieldNames])
    }
    // get initialization request results to display
    initMap = (data) => {
        // generate [domain][phase][tab][fields] map
        // scan all data list and build/parse dynamically
        // Attention: repeater vs. group vs. none...
        // then add more *field* info from js
        let familyTabList = this.initTabs(data, 'digma_families')
        let parentTabList = this.initTabs(data, 'digma_parents')
        let familyFieldList = familyTabList.map(tabName => this.initFields(tabName, data))
        let parentFieldList = parentTabList.map(tabName => this.initFields(tabName, data))
        this.setState({data, familyTabList, parentTabList, familyFieldList, parentFieldList})
    }
    componentWillUnmount(){ 
        this._isMounted = false
    }
    inUpdate = onOff => {
        //console.log("inUpdate =", onOff)
        if (this._isMounted)
            this.setState({isUpdating:onOff})
    }
    // get query results to display
    showMe = (data) => {
        if (data === undefined || data.length === 0)
            console.log('showMe = data is EMPTY')
        ////else console.log('showMe = ' + data)
        this.setState({result: data})
    }
    validateQuery = (rules, gcond) => {
        if (rules === undefined || rules.length === 0)
            return [0, 'לא נמצאו הגדרות כללים']
        if (gcond === undefined || (rules.length > 1 && gcond === ""))
            return [0, 'יש להגדיר *או* או *וגם*']
        if (gcond === 'OR')
            return [0, 'מצטערים *או* לא נתמך עדיין']

        // Validate each and every rule
        let emptyF = false
        let errList = ""
        rules.map((item, index) => {
            Object.keys(item).forEach(key => {
                if (item[key] === null || item[key] === ""){
                    emptyF = true
                    errList += (index+1) + " " + key + ", "
                }
            })
            return null
        })
        if (emptyF)
            return [0, 'חסרות הגדרות כללים בשורות:' + errList]
        return [1, 'ok']
    }   
    saveQueryCb = (crud, response, qtitle, rules, cond) => {
        if (crud === 'CREATE'){
            if (response !== [] && response > 0 ){ // save succeed - add to predefined list
                let x = Object.assign(this.state.preDefinedQueries)
                x.push({name:qtitle, cond: cond, rules: rules, id: response})
                function compare( a, b ) {
                    if ( a.name < b.name ) return -1;
                    if ( a.name > b.name ) return 1;
                    return 0;
                }
                x.sort( compare );
                return this.setState({preDefinedQueries: x, selectedRule: qtitle})
            }
            return alert('ההגדרה לא נשמרה')
        }
        return alert('Unexpected crud value= ', crud)
        //console.log('saveQueryCb return =', response)
    }
    justCompare = (x, y) => x.name === y
    listFind = (list, queryName) => {
        let found = list.find((item) => item.name === queryName)
        return found
     }
    saveQuery = (event, rulelist, groupCond) => {
        event.preventDefault()
        let x = this.validateQuery(rulelist, groupCond)
        if (x[0] === 0) // invalid definition
            return alert(x[1])
        
        // NIH: check that query is not already saved

        // get name from user first
        
        const list = this.state.preDefinedQueries
        var queryName = prompt('שם ההגדרה: ')
        // check if name exists
        if (list !== undefined && list !== [] && list.length > 0){
            var found = list.find((item) => item.name === queryName)
            ////    var found = list.find(function (item){
          ////          return item.name === queryName
            ////})
            for (let i = 0; found !== undefined ; i++){ // must be new name
                alert('השם ' + queryName + ' בשימוש, בחר שם חדש')
                queryName = prompt('שם ההגדרה: ')
                found = this.listFind(list, queryName)
               // found = list.find(function (item){
               //     return item.name === queryName
               // })
                if (i > 5){
                    alert('ההגדרה נכשלה במציאת שם חדש')
                    return null
                }
            }
        }
        // NIH: check that query NAME is not already used

        // keep in database as new CPT
        // console.log('DO saveQuery rules=' + rulelist + " groupcond= " + groupCond)
        crudQuery('CREATE', 0, queryName, rulelist, groupCond, this.inUpdate, this.props.mbouser, this.saveQueryCb, this.restError)
        return null
    }
    doQuery = (event, rules, gcond, data) => {
        event.preventDefault()
        let vres = this.validateQuery(rules, gcond)
        if (vres[0] === 0) // error
            return alert(vres[1])
       
        ////console.log('doQuery ='+ rules + "  cond= " + gcond)
        //if (JSON.stringify(this.state.rules) === JSON.stringify(rules) )
        //    console.log("========== NO NEED for setstate")
        //else console.log("+++++++++ MUST perform setstate")
        /////this.setState({ rules:rules, gcond:gcond}) // MUST perform setstate
        //alert("Query OK sent to server... ")
        let urules = rules.map(r => {
            let found = Object.values(data).find(item => r['tab'] === item['title']) // get the tab definition
            let newr = Object.assign(r)
            newr.tabKey = found['fields'][0]['key']
            newr.tabName = found['fields'][0]['name']
            let field = Object.values(found['fields'][0]['sub_fields']).find(item => r['field'] === item['label']) // find field key
            newr.fieldName = field['name']

            return (newr)
           // let tabkey = Object.entries(r)
        })
        ////console.log('doQuery URULES=' + urules + "  cond= " + gcond + ' same as above')

        processQuery(urules, gcond, this.inUpdate, this.props.mbouser, this.showMe, this.restError); // cb
        return null
    }
    // one line
    displayLine = (line) => {
        let x = line.map((column, index) => <td key={index} className='qb-col'>{column}</td>)
        /*{
            if ((index > 0 && index % 9 !== 0) || index === 0) 
                return (<span key={index} className='qb-col'>{column}</span>)
            return (<span key={index} className='qb-col qb-col-nl'>{column}</span>)
        })*/
        return x
    }
    /* {
        dataField: 'id',
        text: 'Product ID'
        }
    
    resultTableHeader = (line) => {
        let x = []
        ////line.map((column, index) => {x.push({dataField: index.toString(), text: column})})
        line.map((column, index) => x = [...x, {dataField: index.toString(), text: column, sort: true}])
        //line.map((column, index) => { x = [...x, {dataField: index.toString(), text: column}]} )
        return x
    }*/
    
    displayQueryResults = (result, rules, admin) => {
        if (rules === "" || rules.length < 1) return null
        
        let query = rules.map((r, index) => 
                <div key={index} className="qb-query-display">
                    <span>שאילתא: </span>
                    <span>{r.entity}  </span>
                    <span>{r.phase}  </span>
                    <span>{r.tab}  </span>
                    <span>{r.field}  </span>
                    <span>{r.condition}  </span>
                    <span>{r.input}  </span>
                </div>
            )
        if (result === "" || result.length < 2 || result[0] === 0 || result[0] === "")
            return  <React.Fragment> {query}  <h5>לא נמצאו תוצאות</h5>  </React.Fragment>

        const header = <tr className="qb-result-header">
                            <td>#</td>{this.displayLine(qb_translateLine(result[0], rules[rules.length-1].tab))}
                        </tr>

        //const numFields = qb_translateLine(result[0], rules[0].tab).length // to crop fields from end

        const rows = result.map((line, index) => {
            if (index===0 ) return null
            let trclass = index > 0 && index%2 === 0 ? 'even-line' : 'odd-line'
            return (<tr className = {trclass} key={index}><td>{index}</td>{this.displayLine(line)}</tr>)
        })
        const dynamic_width = result[0].length > 6 ? result[0].length * 200 : 1140
        return (<div className="qb-result-wrapper" style={{width:dynamic_width+'px'}}>
                    {/*query*/}
                    <h5>נמצאו {result.length - 1} תוצאות ({result[0].length} עמודות)</h5>
                    <XLDownload 
                        title={rules[0].tab+'-'+rules[0].phase} 
                        header={qb_translateLine(result[0], rules[0].tab)} 
                        rows={result} />
                    
                    { admin && <button type="button"  className="btn btn-success pull-right update-button" 
                        onClick={event => this.saveQuery(event, this.state.rulelist, this.state.groupCond)}>
                         <i className='fa fa-save'></i>שמירת הגדרה</button>}
                    <br />
                    
                    {/*<BootstrapTable products={result} columns={this.resultTableHeader(qb_translateLine(result[0], rules[0].tab)) } />*/}

                    {/*<button type="button"  className="btn btn-success pull-left success-button" 
                                            onClick={() => this.printResults() }>בקרוב הדפסה</button>*/}
                    <table className="qb-result-table">
                        <tbody>
                            {header}
                            {rows}
                        </tbody>
                    </table>
                    
                </div>)
    }

    selectRule = (event) => { // Select and "activate" - set as current rule
        event.preventDefault()
        let ruleName = event.target.value
        if (ruleName === "") // just cancel previous selection
            return this.setState({ selectedRule: ruleName})
        
        let preQ = [...this.state.preDefinedQueries]
        preQ.map(item => {
            if (item.name === ruleName)
                return this.setState({ rulelist:item.rules, groupCond:item.cond, selectedRule: ruleName}) // MUST perform setstate
            return null
        })
        return null
    }
    PreDefinedRuleList = (preDefinedQueries, selectedRule) => {
        return (
            <select onChange={event => this.selectRule(event)} value={selectedRule} >
                <option key='999999' value='' >בחירה מתוך הגדרות שנשמרו</option>
                {preDefinedQueries !== [] && preDefinedQueries.map((item,index) => 
                    <option key={index} value={item.name}>{item.name}</option>)}
            </select>
        )
    }
    delQueryDefinitionCb = (response, qid) => alert('הגדרת שאילתה ID=' + qid + ' נמחקה מהמאגר')

    delQueryDefinition = (event, selectedRule) => {
        event.preventDefault()
        if (selectedRule === "")
            return null
        if (!window.confirm('האם באמת לבצע מחיקה?'))
            return alert('בקשת המחיקה בוטלה')
        
        var newlist = Object.assign(this.state.preDefinedQueries)
        var pos2 = ""
        let found = newlist.find(function (item, index){
            if (item.name === selectedRule)
                pos2 = index
            return index++
        })
        ///// UGLY - may fail delete on server, but remove from list anyway... or is it ok???
        ///// so, users may delete & will see the definition agaim on their next activation..
        newlist.splice(pos2,1);
        crudQuery('DELETE', found['id'], "", "", "", this.inUpdate, this.props.mbouser, this.delQueryDefinitionCb, this.restError)

        this.setState({preDefinedQueries:newlist}) // modify screen after post removal
    }
    isActive = cond => this.state.groupCond === cond ? "active" : ""

    render(){
        const { data, result, isUpdating, domainList, familyTabList, preDefinedQueries, selectedRule,
                    parentTabList, familyFieldList, parentFieldList, rulelist, groupCond} = this.state
        const lname = "btn btn-primary"
        const admin = this.props.mbouser.user_role[0] === 'administrator'

        if (isUpdating)
            return <YSpinner qb='מעבד...' /> 

        return ( 
            <div className="qb-query">
                <h2>מחולל שאילתות</h2>
                <h4>הגדרת כללי חיפוש </h4>
                <h6 className='qb-predefined'>טעינת הגדרה קיימת <span className='qb-predefined'>{this.PreDefinedRuleList(preDefinedQueries, selectedRule)}</span>
                    { admin && <span className="qb-del-definition">
                        <button type="button"  className="btn btn-success exec-button" 
                            onClick={event => this.delQueryDefinition(event, selectedRule)}><i className='fa fa-trash-o'></i>מחק הגדרה</button>
                    </span>}
                </h6>
                    
                <button type="button"  className="btn btn-success pull-left exec-button" style={{marginTop: '20px'}}
                    onClick={event => this.doQuery(event, rulelist, groupCond, data)}><i className='fa fa-play fa-rotate-180'></i>בצע שאילתה</button>
                
                <div className="qb-group">
                    <button type="button"  className="btn btn-success pull-left exec-button" onClick={this.addRule}><i className='fa fa-plus'></i>הוספת כלל</button>
                    <div className="btn-group group-conditions">
                        <GroupCondLable key={"AND"} cond="AND" text="וגם" setActive={this.setActive} 
                                    classname={lname + " " + this.isActive('AND')} />
        {/*<GroupCondLable key={"OR"} cond="OR" text="או" setActive={this.setActive} 
        classname={lname + " " + this.isActive('OR')} />  */}        
                    </div>
                    {/*<QBrule {...this.props} delrule={this.removeRule} />*/}
                    {rulelist.map((item, index) => item === undefined ? "" :
                        <QBrule {...item} key={index} index={index} 
                                onChange={this.ruleParamChange2} 
                                delrule={this.removeRule} 
                                duprule={this.duplicateRule}
                                uprule={this.upRule} 
                                familyTabList={familyTabList} 
                                parentTabList={parentTabList}
                                domainList = {domainList}
                                familyFieldList = {familyFieldList} 
                                parentFieldList = {parentFieldList}
                        />
                    )}
                </div>
       
                <h4>תוצאת החיפוש</h4>
                {result === "" ? <div className="qb-fill"></div> : this.displayQueryResults(result, rulelist, admin)}
            </div>)
    }
}

class QBrule extends React.PureComponent{
    render(){
        const { onChange, entity, phase, tab, condition, field, input, delrule, duprule, uprule, index,
                    domainList, familyTabList, parentTabList, familyFieldList, parentFieldList } = this.props
        return (
            <div className="qb-rule">
                <EntitySel onChange={onChange} index={index} value={entity} domainList={domainList} />
                <PhaseSel onChange={onChange} index={index} value={phase} cond={entity} />
                <TabSel onChange={onChange} index={index} value={tab} cond={entity} 
                            familyTabList={familyTabList} parentTabList={parentTabList} />
                <FieldSel onChange={onChange} index={index} value={field} cond={entity} tab={tab}
                            familyFieldList = {familyFieldList} parentFieldList = {parentFieldList} />
                <ConditionSel onChange={onChange} index={index} value={condition} cond={field} />
                <InputVal onChange={onChange} index={index} tab={tab} field={field} value={input} cond={condition} 
                            entity={entity} familyFieldList = {familyFieldList} parentFieldList = {parentFieldList} />
                <button type="button"  className="btn btn-success pull-left first-update-button" 
                        onClick={(event) => delrule(event,index)}><i className='fa fa-trash-o'></i></button>
                <button type="button"  className="btn btn-success pull-left update-button" 
                    onClick={(event) => duprule(event,index, true)}><i className='fa fa-files-o'></i></button>
                <button type="button"  className="btn btn-success pull-left update-button" 
                    onClick={(event) => uprule(event,index, true)}><i className='fa fa-arrow-up'></i></button>
                <button type="button"  className="btn btn-success pull-left update-button" 
                    onClick={(event) => uprule(event,index, false)}><i className='fa fa-arrow-down'></i></button>
            </div>
        )
    }
}
const EntitySel = props => {
    return ( // entity is the domain
        <select onChange={event => props.onChange(event, 'entity', props.index)} value={props.value} >
            <option key="תחום החיפוש" value="" >תחום החיפוש</option>
            {props.domainList.map(item => <option key={item} value={item} >{item}</option>)}
        </select>
    )
}

// TODO <option key="אינטייק"  <option key="הפניות"
const PhaseSel = props => {
    return (
        <select onChange={event => props.onChange(event, 'phase', props.index)} value={props.value} >
            <option key="בחירת שלב" value="" >בחירת שלב</option>
            <option key="תחילת תוכנית" value="תחילת תוכנית" >תחילת תוכנית</option>
            <option key="אמצע תוכנית" value="אמצע תוכנית" >אמצע תוכנית</option>
            <option key="סיום תוכנית" value="סיום תוכנית" >סיום תוכנית</option>
            <option key="מצב נוכחי" value="מצב נוכחי" >מצב נוכחי</option> 
    {/*props.cond === 'משפחה' && <option key="אינטייק" value="אינטייק" >אינטייק</option>*/}       
    {/*props.cond === 'משפחה' && <option key="הפניות" value="הפניות" >הפניות</option>  */} 
        </select>
    )
}

//const TabSel = props => {
const TabSel = ({cond, index, value, familyTabList, parentTabList, onChange }) => {
    if (cond === "")
        return "" // <span>לא נבחר תחום</span>
    const oplist = cond === 'משפחה' ? familyTabList: parentTabList //familyTabs : parentTabs
    return (
        <select onChange={event => onChange(event, 'tab', index)} value={value} >
            <option key="בחירת לשונית" value="" >בחירת לשונית</option>
            {oplist.length === 0 ? <option key={0} value={''} >{'תקלת מערכת'}</option>
                : oplist.map(item => <option key={item} value={item} >{item}</option>)}
        </select>
    )
}

// familyFieldList, parentFieldList

const genFieldList = (list, tab) => {
    let item = list.find(item => item[0] === tab)
    if (item[2] === undefined){
        console.log("genFieldList ietn[2] UNDEFINED tab="+tab+ "  item=" + item)
        return ['error=item2']
    }
    let flist = Object.entries(item[2]).map(el => {
        if (el['name'] !== undefined){
            if (el['name'] !== 'id')
                return el['name']
            return null
        }
        if (el[1]['name'] !== undefined && el[1]['name'] !== "id") 
            return el[1]['label']
        return null
    })
    flist = flist.filter(item => item !== null)
    return flist.sort()
}

const FieldSel = ({cond, tab, familyFieldList, parentFieldList, onChange, index, value}) => {
    if (cond === "" || tab === "")
        return "" // <span>לא נבחרה לשונית</span>

    const oplist = genFieldList(cond === 'משפחה'? familyFieldList : parentFieldList , tab)

    return (
        <select onChange={event => onChange(event, 'field', index)} value={value} >
            <option key="בחירת שדה" value="" >בחירת שדה</option>
            {oplist.map((item, index) => <option key={index} value={item} >{item}</option>)}
        </select>
    )
}

// TODO  'מכיל', 'לא מכיל'
const ConditionSel = props => {
    if (props.cond === "")
        return "" // <span>לא נבחרה לשונית</span>

    const oplist = ['שווה', 'שונה', 'גדול מ', 'קטן מ', 'גדול או שווה', 'קטן או שווה', 'מכיל', 'לא מכיל', 'בטווח', 'מחוץ לטווח']

    return (
        <select onChange={event => props.onChange(event, 'condition', props.index)} value={props.value} >
            <option key="בחירת תנאי" value="" >בחירת תנאי</option>
            {oplist.map(item => <option key={item} value={item} >{item}</option>)}
        </select>
    )
}
// familyFieldList = {familyFieldList} parentFieldList = {parentFieldList}
const InputVal = props => { 
    if (props.cond === "")
        return ""
    let iplaceHolder = "הקלד ערך או השאר ריק"
    if (props.cond === "בטווח" || props.cond === 'מחוץ לטווח')
        iplaceHolder = 'נמוך-גבוה'
    let valueList = fieldTypeMap(props.entity, props.tab, props.familyFieldList, props.parentFieldList, props.field)
    //console.log('InputVal field type=', valueList )
    if (valueList !== undefined && valueList !== "" && valueList.length > 0){
        return (
            <select onChange={event => props.onChange(event, 'input', props.index)} value={props.value} >
                <option key="נא לבחור" value="" disabled >נא לבחור</option>
                {valueList.map(item => <option key={item} value={item} >{item}</option>)}
            </select>
        )
    }
    return ( <input type="text" // name={tpc.name} id={tpc.id}
                    placeholder = {iplaceHolder} 
                    value={props.value} onChange={event => props.onChange(event, 'input', props.index)}    />)
}

class GroupCondLable extends React.PureComponent{ // (cond, text, setActive, classname)  => {
    render(){
        const { classname, setActive, cond, text } = this.props
        const cname = "builder-basic_group_0_cond"

        return (
            <label className={classname}>
                <input type="radio" onClick={event => setActive(event, cond)} className={cname} value={cond} />{text}
            </label>)
    }
}